<section class="panel p-4">
  <h2 class="h5 mb-3">Exportacao de ponto</h2>
  <app-painel-filtros-exportacao
    [empregadores]="empregadores"
    [empregadorSelecionado]="empregadorSelecionado"
    [funcionarioSelecionado]="funcionarioSelecionado"
    [departamentoSelecionado]="departamentoSelecionado"
    [buscaFuncionario]="buscaFuncionario"
    [departamentos]="departamentos"
    [funcionariosFiltrados]="funcionariosFiltrados"
    [dataInicial]="dataInicial"
    [dataFinal]="dataFinal"
    [formato]="formato"
    [rotuloFuncionario]="rotuloFuncionario"
    [detalheFuncionario]="detalheFuncionario"
    (empregadorSelecionadoChange)="empregadorSelecionadoChange.emit($event)"
    (departamentoSelecionadoChange)="alterarDepartamento($event)"
    (buscaFuncionarioChange)="alterarBuscaFuncionario($event)"
    (dataInicialChange)="dataInicial = $event"
    (dataFinalChange)="dataFinal = $event"
    (formatoChange)="formato = $event"
    (abrirModalFuncionarios)="abrirModalFuncionarios()"
    (selecionarFuncionario)="selecionarFuncionario($event)"
    (limparResultado)="limparResultado()"
    (pesquisar)="pesquisar()"
    (limpar)="limpar()"
    (gerar)="gerar()"
    (acertoServidor)="abrirAcertoServidor()"
    (acertoGeral)="abrirAcertoGeral()">
  </app-painel-filtros-exportacao>

  <app-grade-folha-ponto
    [linhas]="linhas"
    [linhaEditando]="linhaEditando"
    [batidasEdicao]="batidasEdicao"
    (batidasEdicaoChange)="batidasEdicao = $event"
    (editarOuSalvar)="editarOuSalvarLinha($event)"
    (cancelarEdicao)="cancelarEdicaoLinha()"
    (verHistorico)="abrirHistorico($event)">
  </app-grade-folha-ponto>

  <app-modal-funcionario-exportacao
    [aberta]="modalFuncionariosAberta"
    [termo]="buscaFuncionarioModal"
    [funcionarios]="funcionariosModal"
    [rotuloFuncionario]="rotuloFuncionario"
    [detalheFuncionario]="detalheFuncionario"
    (termoChange)="buscaFuncionarioModal = $event"
    (selecionar)="selecionarFuncionario($event)"
    (limpar)="limparBuscaFuncionarioModal()"
    (fechar)="fecharModalFuncionarios()">
  </app-modal-funcionario-exportacao>

  <app-modal-historico-folha
    [aberta]="historicoAberto"
    [carregando]="historicoCarregando"
    [titulo]="historicoTitulo"
    [erro]="historicoErro"
    [alteracoes]="historicoAlteracoes"
    (fechar)="fecharHistorico()">
  </app-modal-historico-folha>

  <app-modal-acerto-ponto
    [aberta]="modalAcertoAberta"
    [carregando]="carregandoAcerto"
    [confirmando]="confirmandoAcerto"
    [preview]="previewAcerto"
    (fechar)="fecharAcerto()"
    (confirmar)="confirmarAcerto($event)">
  </app-modal-acerto-ponto>
</section>
